import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";
import Dropzone from "react-dropzone";
import * as colors from "components/colors/Colors";

const useStyles = makeStyles((theme) => ({
    dropZone: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(0.5),
        padding: theme.spacing(1.75, 1.5),
        border: `1.5px dashed ${colors.clinicalOutline}`,
        borderRadius: 10,
        background: colors.clinicalPageBackground,
        textAlign: "center",
        cursor: "pointer",
        outline: "none",
        transition: "border-color .15s, background .15s",
        "&:hover, &:focus-visible": {
            borderColor: colors.clinicalAccentTeal,
            background: colors.clinicalAccentTealSoft,
        },
    },
    draggedOverDropZone: {
        borderColor: colors.clinicalAccentTeal,
        background: colors.clinicalAccentTealSoft,
    },
    dropZoneIcon: {
        fontSize: 22,
        color: colors.clinicalAccentTeal,
    },
    dropZoneText: {
        fontSize: "0.88rem",
    },
    dropZoneAction: {
        fontWeight: 700,
        color: colors.clinicalAccentTeal,
    },
    dropZoneHelp: {
        fontSize: "0.8rem",
        color: colors.clinicalMutedText,
    },
}));

const ClinicalReportDropZone = ({onDrop, DropZoneIcon, dropZoneAction, dropZoneText, dropZoneHelp}) => {
    const classes = useStyles();
    return (
        <Dropzone onDrop={onDrop}>
            {({getRootProps, getInputProps, isDragActive}) => (
                <div {...getRootProps()} className={`${classes.dropZone} ${isDragActive ? classes.draggedOverDropZone : ""}`}>
                    <input {...getInputProps()} />
                    <DropZoneIcon className={classes.dropZoneIcon} />
                    <Typography className={classes.dropZoneText}>
                        <span className={classes.dropZoneAction}>{dropZoneAction}</span> {dropZoneText}
                    </Typography>
                    <Typography className={classes.dropZoneHelp}>{dropZoneHelp}</Typography>
                </div>
            )}
        </Dropzone>
    );
};

export default ClinicalReportDropZone;
